import { inject, Injectable } from '@angular/core';
import { AuthenticationSandbox } from '@app/authentication/sandboxes/authentication.sandbox';
import { TransactionStore } from '@app/transaction/store/transaction.store';
import { skipWhileEmpty } from '@core/rxjs';
import { TransactionService } from '@smooved-lib/transaction/services/transaction.service';
import { combineLatest } from 'rxjs';
import { filter, mergeMap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class TransactionSandbox {
    private readonly transactionService = inject(TransactionService);
    private readonly authenticationSandbox = inject(AuthenticationSandbox);
    private readonly transactionStore = inject(TransactionStore);

    public getTransaction(): void {
        combineLatest([this.authenticationSandbox.userIdOnce$.pipe(skipWhileEmpty()), this.authenticationSandbox.isMoverOnce$])
            .pipe(
                filter(([_, isMover]) => isMover),
                mergeMap(([id, _]) => this.transactionService.getTransaction(id)),
            )
            .subscribe((response) => {
                this.transactionStore.setTransaction(response);
            });
    }
}
